import { FormGroup } from '@angular/forms';

export enum ENUM_CALLBACK_TRANFORMS {
  transformInputToUpperCase = 'transformInputToUpperCase',
  transformToCurrency = 'transformToCurrency',
}

export const getCssError = function (form: FormGroup, field: string) {
  return getIsInvalid(form, field) ? 'error-border' : '';
}

export const getIsInvalid = function (form: FormGroup, field: string) {
  return form.get(field)!.errors && form.get(field)!.touched;
}

